var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Cards',{staticClass:"testimonial-cards",attrs:{"perRow":4}},_vm._l((_vm.testimonials),function(testimonial){return _c('TestimonialCard',{key:testimonial.Id,attrs:{"testimonial":testimonial}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }